module.exports = {
      id: "gztrending-usage",
      viewBox: "0 0 18.806 24.145",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#gztrending",
      toString: function () {
        return this.url;
      }
    }